"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Flex = _interopRequireDefault(require("../Flex"));

var _ButtonGroupOption = _interopRequireDefault(require("./ButtonGroupOption"));

var _excluded = ["name", "value", "options", "disabled", "size", "onChange", "variant"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

// Setting a transform here creates a stacking context, so the we can use z-index
// in ButtonGroupOption without worrying about z-index conflicts with other components
var ButtonGroupWrapper = ( /*#__PURE__*/0, _styledBase["default"])(_Flex["default"], {
  target: "esu5jem0",
  label: "ButtonGroupWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "41q668",
  styles: "transform:scale(1);"
} : {
  name: "41q668",
  styles: "transform:scale(1);",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ButtonGroup = function ButtonGroup(_ref) {
  var name = _ref.name,
      value = _ref.value,
      options = _ref.options,
      disabled = _ref.disabled,
      size = _ref.size,
      onChange = _ref.onChange,
      variant = _ref.variant,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(ButtonGroupWrapper, (0, _extends2["default"])({
    role: "radiogroup",
    "aria-label": name
  }, rest), options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(_ButtonGroupOption["default"], {
      key: index,
      id: "buttonGroup_".concat(name, "_").concat(index),
      name: name,
      label: option.label,
      value: option.value,
      checked: option.value === value,
      disabled: disabled || option.disabled,
      size: size,
      totalOptions: options.length,
      onChange: onChange,
      variant: variant
    });
  }));
};

ButtonGroup.propTypes = {
  name: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].node.isRequired,
    value: _propTypes["default"].string.isRequired,
    disabled: _propTypes["default"].bool
  })).isRequired,
  onChange: _propTypes["default"].func.isRequired,
  disabled: _propTypes["default"].bool,
  size: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string, _propTypes["default"].array]),
  variant: _propTypes["default"].string
};
ButtonGroup.defaultProps = {
  disabled: false,
  size: 'base',
  variant: 'default'
};
var _default = ButtonGroup;
exports["default"] = _default;